import type { Basemap, BasemapSource } from './types';

// OpenFreeMap serves OpenMapTiles vector tiles and fonts with no key and no usage limits.
// Upgrade path: self-hosted Protomaps/OpenMapTiles on R2 (change the URL only).
const OMT = {
  url: 'https://tiles.openfreemap.org/planet',
  attribution:
    '<a href="https://openfreemap.org">OpenFreeMap</a> © <a href="https://www.openmaptiles.org/">OpenMapTiles</a> Data from <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
};

const LIST: Basemap[] = [
  {
    id: 'terrain',
    name: 'Terrain',
    attribution: OMT.attribution,
    relief: { hillshade: 1, tint: true, contours: true },
    vector: OMT,
  },
  {
    id: 'topo',
    name: 'Topo',
    tiles: ['a', 'b', 'c'].map((s) => `https://${s}.tile.opentopomap.org/{z}/{x}/{y}.png`),
    tileSize: 256,
    maxzoom: 17,
    attribution:
      'Map: © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, SRTM | Style: © <a href="https://opentopomap.org">OpenTopoMap</a> (CC-BY-SA)',
    // OpenTopoMap already has hillshade and contours baked in.
    relief: { hillshade: 0, tint: false, contours: false },
  },
  {
    id: 'satellite',
    name: 'Satellite',
    tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
    tileSize: 256,
    maxzoom: 19,
    attribution: 'Imagery: Esri, Maxar, Earthstar Geographics, and the GIS User Community',
    relief: { hillshade: 0, tint: false, contours: true },
  },
  {
    id: 'osm',
    name: 'Streets',
    tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
    tileSize: 256,
    maxzoom: 19,
    attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    relief: { hillshade: 0.6, tint: false, contours: true },
  },
];

export class DefaultBasemaps implements BasemapSource {
  readonly id = 'default';
  list(): Basemap[] {
    return LIST;
  }
}
